
import React from "react";
import { Camera } from "lucide-react";

export function ImageCaptureInitial() {
  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-6 animate-fade-in p-6">
      <div className="w-24 h-24 rounded-full bg-primary/10 flex items-center justify-center animate-pulse-soft">
        <Camera size={40} className="text-primary" />
      </div>
      <div className="text-center space-y-2">
        <h3 className="font-display font-medium text-lg">Capture Objects</h3>
        <p className="text-muted-foreground text-sm max-w-xs">
          Take a photo of objects around you to get creative ideas
        </p>
      </div>
    </div>
  );
}

export default ImageCaptureInitial;
